import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function ComboBox({
  lable,
  options,
  value,
  setValue,
  inputValue,
  setInputValue,
  width,disabled
}) {
  const [val, setVal] = useState(null);
  useEffect(() => {
    if(options){

      const newValue =value? options?.find((option) => option.value === value) || null:null
      setVal(newValue);
    }
  }, [value]);

  return (
    <Autocomplete
      disablePortal
      //disableClearable
      disabled={disabled}
      value={val}
      onChange={(event, newValue) => {
        setValue(newValue ? newValue.value : null);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      isOptionEqualToValue={(option, value) =>
        option?.value === value?.value && option?.key === value?.key
      }
      options={options}
      sx={{
        width:width?width: "95%",
        marginX: "4px",
        "& .MuiAutocomplete-inputRoot": {
          padding: "1px",
        },
      }}
      renderInput={(params) => <TextField {...params} label={lable} />}
    />
  );
}

export default ComboBox;
